import React, {Fragment, useState, useEffect} from 'react'
import axios from 'axios';
import { Cabecera } from '../components/Cabecera';
import { Footer } from '../components/Footer';
import { ItemSlider } from '../components/ItemSlider';
import {Listadopatrocinadores} from '../components/Listadopatrocinadores'
import { ConsoleView } from 'react-device-detect';


export const Home = (props) => {

    function groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
           const key = keyGetter(item);
           if(key >= 3){
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
           }
      });
      return map;
    }

  
    const [listaEventos, setListaEventos] = useState(false)
    const fetchListaEventos = async () => {
      let dataFormEventos = {  
          "formato": "home_adnpymes",
          "idUsuario": localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-idu`)
      }
      
      let axiosConfig = {
          headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json',
              'Authorization':`Bearer ${localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-token`)}`
          },  
      };
      axios.post(`${process.env.REACT_APP_URL_API}formatos/obtenerformato`, dataFormEventos, axiosConfig)
      .then((res) => {
      
          setListaEventos(res.data.data)
          
      })
      .catch((err) => {
         props.removeAuth()
      }) 
    }

    useEffect(() => {
        fetchListaEventos();
    },[])

    if(!listaEventos) { return(<div></div>) }    

    return(
        <Fragment>
            <Cabecera imagen={true} urlimagen={listaEventos[0].imagen} texto={listaEventos[0].texto} top={false} removeAuth={props.removeAuth} datosCabecera={listaEventos} />
            <section className="py-5">
                <div className="container">
                   <div className="row">
                      <div className="col-md-12">
                          <div className="titulopagina">
                            <div className="nombre">Hola, {localStorage.getItem(`${process.env.REACT_APP_ID_STORAGE}-nombre`)}</div> 
                            <div className="tituloseccion">Próximas sesiones</div>
                          </div>
                      </div>
                    </div>
                </div>
                <div className="listado-sliders">{console.log("EVENTOS::",listaEventos)}
                {
                    listaEventos.map(item =>
                    <Fragment key={Math.random() * 57005}>
                    {item.idZona === 2 && 
                        <div className="toggleColor">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="contenedor-slider">
                                            <div className="slider">
                                                { item.eventos.map(evento =>
                                                    <ItemSlider evento={evento} logEvento={props.logEvento} eventosInscritos={item.eventosInscritos} key={Math.random() * 57005} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    }
                    </Fragment>
                    )
                }
                </div>
                <div className="container">
                   <div className="row">
                      <div className="col-md-12">
                          <div className="titulopagina">
                            <div className="tituloseccion">
                                Sesiones pasadas
                                <div className="subtituloseccion">Accede a la grabaciones de todas las sesiones que ya se han realizado.</div>
                            </div>
                            
                          </div>
                      </div>
                    </div>
                </div>
                <div className="listado-sliders">
                {
                    listaEventos.map(item =>
                    <Fragment key={Math.random() * 57005}>
                    {item.idZona === 2 && 
                        <div className="toggleColor">
                            <div className="container">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="contenedor-slider">
                                            <div className="slider">
                                                { item.eventosPasados.map(evento =>
                                                    <ItemSlider evento={evento} logEvento={props.logEvento} eventosInscritos={item.eventosInscritos} key={Math.random() * 57005} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> 
                    }
                    </Fragment>
                    )
                }
                </div>
                <div className="listado-patrocinadores">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 sponsor home">
                            <Fragment>
                                { 
                                    [...groupBy(listaEventos, item => item.idZona)]
                                    .map(([key, value],index) => {
                                        return(<div key={Math.random() * 57005}><Listadopatrocinadores indexitem={index} keyitems={key} items={value}   /></div>)
                                    })
                                }
                            </Fragment>
                            </div>
                        </div>
                     </div>
                </div>
            </section>
            <Footer />
        </Fragment>
    )

}